// Extracted from web/components/WorkbenchDialogs.tsx; behavior and declaration bodies preserved.
import type { Dialect, ModelType } from "../../shared/contracts";

export const dialects: Dialect[] = [
  "postgresql",
  "oracle",
  "sqlserver",
  "mysql",
  "ase",
];
export const modelTypes: ModelType[] = [
  "conceptual",
  "logical",
  "logical-physical",
  "physical",
];
